import { Link2, ScanLine, RefreshCw } from "lucide-react";
import { CarlinkSticker } from "../brand/CarlinkSticker";
import { WindshieldScene } from "../brand/WindshieldScene";
import { SectionHeading } from "../common/SectionHeading";

const POINTS = [
  { icon: ScanLine, text: "Readable by any modern phone camera." },
  { icon: Link2, text: "Encodes only a CARLINK ID — never your personal details." },
  { icon: RefreshCw, text: "Change your number anytime. The sticker keeps working." },
];

export const StickerSection = () => (
  <section data-testid="sticker-product-section" className="section-pad">
    <div className="container-x grid items-center gap-14 lg:grid-cols-[0.9fr_1.1fr]">
      <div>
        <SectionHeading label="The sticker" title="One small sticker. A complete digital identity for your vehicle." />
        <ul className="mt-10 space-y-5">
          {POINTS.map(({ icon: I, text }) => (
            <li key={text} className="flex items-start gap-4 text-slate-300">
              <I className="mt-0.5 h-5 w-5 shrink-0 text-[#FF5500]" aria-hidden="true" />
              <span className="text-sm sm:text-base">{text}</span>
            </li>
          ))}
        </ul>
        <div className="mt-12 hidden justify-start sm:flex">
          <div className="rounded-2xl border border-white/10 bg-[#0F111A] p-8">
            <CarlinkSticker size="md" testId="sticker-closeup" />
          </div>
        </div>
      </div>
      <div className="grid gap-5">
        <WindshieldScene
          src="/images/hero-windshield.jpg"
          alt="CARLINK sticker placed on a front windshield"
          testId="sticker-front-windshield"
          stickerClass="right-[30%] top-[25%] scale-[0.8] origin-top-right sm:scale-100"
          size="xs"
          className="aspect-[16/10]"
        >
          <span className="label-mono absolute bottom-4 left-4 text-slate-300">Front windshield</span>
        </WindshieldScene>
        <WindshieldScene
          src="/images/rear-windshield.jpg"
          alt="CARLINK sticker placed on the rear windshield of an SUV"
          testId="sticker-rear-windshield"
          stickerClass="left-[70%] top-[29.5%] scale-[0.24] origin-top-left sm:scale-[0.3]"
          size="xs"
          className="aspect-[16/10]"
        >
          <span className="label-mono absolute bottom-4 left-4 text-slate-300">Rear windshield</span>
        </WindshieldScene>
      </div>
    </div>
  </section>
);
